import { cn } from "@/lib/utils";

// Brand logo: the official EmployGuard image (shield monogram + wordmark).
// variant "dark"  -> plain (for light surfaces).
// variant "light" -> placed on a white chip so the navy wordmark stays visible on dark surfaces.
export function Logo({ variant = "dark", size = 34, className = "" }) {
  const light = variant === "light";
  return (
    <div
      data-testid="brand-logo"
      className={cn("inline-flex items-center", light && "rounded-xl bg-white px-3 py-1.5 shadow-sm ring-1 ring-white/20", className)}
    >
      <img src="/logo.png" alt="EmployGuard — Foreign Workforce Compliance" style={{ height: size }} className="w-auto select-none" draggable={false} />
    </div>
  );
}

export function LogoMark({ size = 32, className = "" }) {
  return <Logo size={size} className={className} />;
}

export default Logo;
